import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';
import { ArrowRight, Check } from 'lucide-react';
import NavBar from '../components/NavBar';
import SmartImage from '../components/SmartImage';

const ModificationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [mod, setMod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('modifications');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    loadMod();
  }, [id]);

  useEffect(() => {
    if (currentPage === 'home') {
      navigate('/');
    } else if (currentPage === 'profile') {
      navigate('/profile');
    } else if (currentPage === 'services') {
      navigate('/services');
    } else if (currentPage === 'maintenance') {
      navigate('/maintenance');
    } else if (currentPage === 'accessories') {
      navigate('/accessories');
    } else if (currentPage === 'parts') {
      navigate('/parts');
    }
  }, [currentPage, navigate]);

  const loadMod = async () => {
    try {
      const modDoc = await getDoc(doc(db, COLLECTIONS.MODIFICATIONS, id));
      if (modDoc.exists()) setMod({ id: modDoc.id, ...modDoc.data() });
    } catch (error) { console.error('Error:', error); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="min-h-screen bg-gray-100"><NavBar currentPage={currentPage} setCurrentPage={setCurrentPage} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} /><div className="pt-24 flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div></div></div>;
  if (!mod) return null;

  return (
    <div className="min-h-screen bg-gray-100">
      <NavBar currentPage={currentPage} setCurrentPage={setCurrentPage} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <div className="pt-24 px-4 pb-12">
        <div className="max-w-4xl mx-auto">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"><ArrowRight className="w-5 h-5" />العودة</button>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-orange-600 p-12 text-white text-center">
              <div className="flex justify-center mb-6">
                <SmartImage
                  src={mod.icon}
                  alt={mod.name}
                  size="xlarge"
                  fallback="⚙️"
                  className="drop-shadow-2xl"
                />
              </div>
              <h1 className="text-5xl font-bold mb-4">{String(mod.name || '')}</h1>
              <div className="flex items-center justify-center gap-8 text-lg"><span className="font-bold text-3xl">{String(mod.price || '')}</span>{mod.duration && <span>{String(mod.duration)}</span>}</div>
            </div>
            <div className="p-8 space-y-6">
              {mod.description && (<div><h3 className="font-bold text-2xl text-gray-900 mb-3">الوصف</h3><p className="text-gray-700 leading-relaxed text-lg">{String(mod.description)}</p></div>)}
              {mod.features && mod.features.length > 0 && (<div className="border-t pt-6"><h3 className="font-bold text-2xl text-gray-900 mb-4">المميزات</h3><ul className="grid md:grid-cols-2 gap-3">{mod.features.map((item, idx) => (<li key={idx} className="flex items-center gap-3 text-gray-700 bg-gray-50 p-3 rounded-lg"><div className="bg-green-100 rounded-full p-1"><Check className="w-5 h-5 text-green-600" /></div>{String(item)}</li>))}</ul></div>)}
              {mod.benefits && mod.benefits.length > 0 && (<div className="border-t pt-6"><h3 className="font-bold text-2xl text-gray-900 mb-4">الفوائد</h3><ul className="grid md:grid-cols-2 gap-3">{mod.benefits.map((item, idx) => (<li key={idx} className="flex items-center gap-3 text-gray-700"><Check className="w-5 h-5 text-blue-600" />{String(item)}</li>))}</ul></div>)}
              {mod.warranty && (<div className="border-t pt-6"><h3 className="font-bold text-xl text-gray-900">الضمان</h3><p className="text-gray-700 mt-2">{String(mod.warranty)}</p></div>)}
              <div className="border-t pt-6">
                <button
                  onClick={() => navigate(`/modification/${mod.id}/book`)}
                  className="w-full bg-gradient-to-r from-red-500 to-orange-600 hover:from-red-600 hover:to-orange-700 text-white font-bold py-4 rounded-xl transition-all shadow-lg text-lg"
                >
                  احجز استشارة مجانية
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModificationDetails;
